<template>
  <div>
    <!-- :get-form-data="fromData" -->
    <list
      row-key="UserId"
      ref="list"
      unit="全阶BOM管理"
      :page="page"
      show-checkbox
      :show-query="true"
      :get-data-func="api.list"
      :queryParamsAppend="params"
      v-if="trendShow"
      urlHash="production/craftsmanship/bom"
      @check-change="checkChange"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
        <el-button type="primary" @click="onExport" >导出</el-button>
      </template>
      <template slot="query">
        <el-form-item label="加工阶段" label-width="120px">
          <el-select v-model="params.Stage" clearable>
            <el-option v-for="item in machiningStageList" :key="item.MachiningStageId" :value="item.MachiningStageId" :label="item.Name"></el-option>
          </el-select>
        </el-form-item>
      </template>
      <template slot="table">
        <slot name="column"></slot>
      </template>
    </list>
  </div>
</template>
<script>


import listMixin from "@/mixins/trend/list";
import list from "@/components/common/trendsTable/list";


export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
      api: require("@/api/production/teProduct").default,
      //加工类型
      machiningStageApi: require("@/api/ba/machiningStage").default,
      trendShow: true,
      params: {
        ProcessStage: null
      },
      machiningStageList: [],
      ids: [],
    };
  },
  created() {
    this.getMachiningStageList()
  },
  methods: {
    getMachiningStageList() {
      this.machiningStageApi.list({Status: 1}).then((res) => {
        this.machiningStageList = res.Data;
      });
    },
    onExport() {
      this.$confirm("是否导出数据？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          var list = this.$refs.list;
          var listParams = list.tempQueryParams;
          var fields = list.tableList.map(x => x.tableName);
          var params = { ...listParams, Fields: fields.join(',') };
          // console.log('onExport', params);
          var loading = this.$loading({
            lock: true,
            text: "正在导出...",
            spinner: "el-icon-loading",
            customClass: "my_loading",
            background: "rgba(0, 0, 0, 0.3)",
          });
          this.api.export(params).then(res => {
            loading.close();
          })
        })
        .catch(() => {});
      
    },
    checkChange(list){
      this.ids = list.map(item => {
        return item.TeProductId;
      })
    },
    del(){
      if( this.ids.length === 0){
        this.$message({type: 'warning', message: '请选择删除的项'})
        return
      }
      this.$confirm("确定删除这些记录?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then((res) => {
        this.api.delete({Ids: this.ids}).then(res => {
          if(res.Code === 0){
            this.$message({type: 'success', message: res.Msg})
              this.reload();
          }else{
            this.$message({type: 'warning', message: res.Msg})
          }
        })
      });
      
    }
  }
};
</script>
